import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { Grid, Button, Typography, Box } from "@mui/material";
import { USERS_API } from "../api";
import { ReactComponent as Logo1 } from "../assets/images/Logo_1.svg";
import { ReactComponent as Female } from "../assets/images/female.svg";
import { ReactComponent as SelectedFemale } from "../assets/images/selected-female.svg";
import { ReactComponent as Male } from "../assets/images/male.svg";
import { ReactComponent as SelectedMale } from "../assets/images/selected-male.svg";
import { useDispatch } from "react-redux";
import Footer from "./Footer";

function GenderDetermination() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [gender, setGender] = useState(0);

  const { mutate: genderSelected } = useMutation(
    ({ username, gender }) => USERS_API.GenderDetermination(username, gender),
    {
      onError: (error) => {
        //todo : inja bayad error handle beshe
      },
      onSuccess: ({ data }) => {
        //todo:in qsmt ham byd payam haye smt server handle beshan
        navigate("/terms");
      },
    }
  );

  const handleSubmitForm = (event) => {
    event.preventDefault();
    if (gender !== 0) {
      let actionType = window.sessionStorage.getItem("action-type");
      switch (actionType) {
        case "isByEmail":
          let email = window.sessionStorage.getItem("email");
          genderSelected({ username: email, gender: gender });
          break;
        case "isByPhoneNumber":
          let phoneNumber = window.sessionStorage.getItem("phoneNumber");
          genderSelected({ username: phoneNumber, gender: gender });
          break;
        default:
          break;
      }
    } else {
      //todo : inja bayad error handle beshe (entekhab gender)
    }
  };

  return (
    <Grid
      container
      maxWidth="1920px"
      width="100%"
      minHeight="100vh"
      bgcolor={{ xs: "#fff", sm: "#FAFAFA", md: "#FAFAFA" }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      fontFamily="VazirMedium"
    >
      <Box
        container
        xs={4}
        bgcolor="#fff"
        borderRadius={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        py={{ xs: 1, sm: 5, md: 4 }}
        px={{ xs: 1, sm: 4, md: 6 }}
        mt={5}
        mb={3}
      >
        <Logo1 />
        <Typography variant="h1" mt={6}>
          احراز جنسیت
        </Typography>
        <Typography variant="h2" mt={2} mb={4} textAlign="center">
          لطفا جنسیت خود را برگزینید.
        </Typography>
        <form onSubmit={handleSubmitForm}>
          <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
            <Box container display="flex" justifyContent="space-between">
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                mr={2}
              >
                <Box height="8.1rem">
                  {gender === 1 ? (
                    <SelectedMale height="8.1rem" width="10rem" />
                  ) : (
                    <Male
                      height="7rem"
                      width="10rem"
                      sx={{ borderRadius: "1rem" }}
                      onClick={() => setGender(1)}
                    />
                  )}
                </Box>
                <Typography variant="h4" my={2}>
                  آقا
                </Typography>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                ml={2}
              >
                <Box height="8.1rem">
                  {gender === 2 ? (
                    <SelectedFemale height="8.1rem" width="10rem" />
                  ) : (
                    <Female height="7rem" width="10rem" onClick={() => setGender(2)} />
                  )}
                </Box>
                <Typography variant="h4" my={2}>
                  خانم
                </Typography>
              </Box>
            </Box>
            <Button type="submit" variant="l" sx={{ mt: 3 }}>
              تایید
            </Button>
          </Box>
        </form>
      </Box>

      <Footer />
    </Grid>
  );
}

export default GenderDetermination;
